import LoaderImage from '../../../assets/images/loader.svg';
import styles from './Loader.module.css';

const Loader = () => {
    return (
        <div className={styles.loader}>
            <img src={LoaderImage} alt="" width={50} />
        </div>
    )
}

export default Loader;